
export default {
    name: 'PopUpSuccessForm',

    computed: {
      isOpen() {
        return this.$store.state['pop-up-success-form']?.isOpen || false;
      },
      settings() {
        return this.$store.state['pop-up-success-form']?.settings || {};
      },
      title() {
        return this.settings.title || 'Спасибо за заявку!';
      },
      message() {
        return this.settings.message || `Ваша заявка успешно отправлена.<br> В ближайшее время мы свяжемся с Вами.`;
      }
    },

    methods: {
      close() {
        this.$store.commit('pop-up-success-form/setOpen', false);
      },
    },
};
